// Shown briefly while a page's code downloads the first time it's opened.
export default function PageLoader() {
  return (
    <div className="flex min-h-[50vh] w-full items-center justify-center" data-testid="page-loader">
      <span className="h-6 w-6 animate-spin rounded-full border-2 border-white/10 border-t-[#00FF66]" />
    </div>
  );
}
